//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  GetSamplingBrandsRequest,
  SamplingBrandsResponse,
} from '@apis/campaign-requests/sampling/products/samplingBrandsApiModel';
import { samplingV2Fetch } from '@apis/campaign-requests/sampling/samplingV2Fetch';
import { makeParams } from '@utils/makeParams';

/**
 * Get brands from catalog
 *
 * GET /api/v2/clients/products/brands
 */
export const getSamplingBrands = async (
  req: GetSamplingBrandsRequest,
  init?: RequestInit,
): Promise<SamplingBrandsResponse> => {
  const params = makeParams(req);

  const response = await samplingV2Fetch(`/products/brands?${params}`, {
    ...init,
    method: 'GET',
  });

  return response.json<SamplingBrandsResponse>();
};
